import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CreateMasterDTO, MatsterApiService } from 'features/master/api/master-api.service';
import { queryClient } from 'providers';

import { MaterQueryKeys } from './query-keys';


const { createWeighbride } = MatsterApiService();

export const useCreateWeighBride = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: CreateMasterDTO) => {
      return createWeighbride(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data:any) => {
        queryClient.invalidateQueries({
          queryKey: MaterQueryKeys.lists(),
        });
        message.success(data?.customMessage)
      }
    },
  );
};










